module.exports = __webpack_public_path__ + "img/izlazna_posta.c16bdc9c.svg";